/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
import React, { useEffect, createContext, useState, useMemo, useContext } from 'react';
import ErrorService, { getErrorCode, getErrorMessage } from '../../containers/Error';
import ErrorPopup from '../ErrorPopup';

const FormioErrorStatusContext = createContext();

export const useErrorStatus = () => useContext(FormioErrorStatusContext);

export default function FormioErrorHandler({ children }) {
    const [error, setError] = useState(null);
    const [errorObj, setErrorObj] = useState(null);

  useEffect(() => {
    if (error) {
      const newErrorObj = ErrorService({
        error: true,
        code: getErrorCode(error),
        message: getErrorMessage(error),
        type: error.type || '',
        state: error.state || '',
      });
      setErrorObj(newErrorObj);
    }
  }, [error]);

    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const contextPayload = useMemo(
        () => ({ setError }),
        [setError],
    );

    return (
      <FormioErrorStatusContext.Provider value={contextPayload}>
        <>
            <ErrorPopup
                open={errorObj?.isError}
                save={errorObj?.save}
                type={errorObj?.type}
                closeErrorPopUp={() => setError(null)}
            />
            {children}
        </>
      </FormioErrorStatusContext.Provider>
    );
}
